<template>
  <div class="your-responsibilities-tab">
    <transition name="fade">
      <GuideVideoBanner
        v-if="guideData && showGuideCard"
        :text="guideData?.content?.text" 
        :subtext="guideData?.content?.subText" 
        :videoUrl="guideData?.content?.videoUrl" 
        :videoThumbnail="guideData?.content?.videoThumbnail" 
        @close="handleGuideClose"
        class="mb-4"
      />
    </transition>
    <div class="your-responsibilities-tab-content">
      <div class="order-text">
        Ordered by greatest impact on your Readiness. Ideally you should get ready
        for them from top to bottom
      </div>
      <YourResponsibilitiesTable
        :headers="headers"
        :data="data"
        :pagination="pagination"
        :levelCounter="levelCounter"
        :loading="loading"
        @onPaginationRequest="$emit('onPaginationRequest', $event)"
        @onSearch="$emit('onSearch', $event)"
        @onAvatarClick="$emit('onAvatarClick', $event)"
        @onPrepareClick="$emit('onPrepareClick', $event)"
        @onLevelsChange="$emit('onLevelsChange', $event)"
        @onClearFilters="$emit('onClearFilters', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import YourResponsibilitiesTable from "@components/YourResponsibilitiesTable/YourResponsibilitiesTable.vue";
import GuideVideoBanner from "@components/GuideVideoBanner/GuideVideoBanner.vue";

const props = defineProps({
  headers: {
    type: Array,
    default: () => [],
  },
  data: {
    type: Array,
    default: () => [],
  },
  pagination: {
    type: Object,
    default: () => ({
      page: 1,
      total: 0,
      perPage: 10,
    }),
  },
  levelCounter: {
    type: Object,
    default: () => ({
      Apprentice: 0,
      Professional: 0,
      Coach: 0,
      Master: 0,
      Novice: 0,
    }),
  },
  loading: {
    type: Boolean,
    default: false,
  },
  guideData: {
    type: Object,
    default: () => ({}),
  },
  showGuideCard: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  "onPaginationRequest",
  "onSearch",
  "onAvatarClick",
  "onPrepareClick",
  "onLevelsChange",
  "onClearFilters",
  "guide-close",
]);

const handleGuideClose = () => {
  emit('guide-close');
};

</script>

<style>
.your-responsibilities-tab {
  width: 100%;
  background-color: #FFFFFF;
}
</style>
